<script>
import { homeComputed, orgComputed, orgMethods } from '@state/helpers';

export default {
  components: {},
  computed: {
    ...homeComputed,
    ...orgComputed,
    colors() {
      return {
        '--color': this.primaryColor,
      };
    },
    profilePage() {
      switch (this.$route.name) {
        case 'Info':
          return 'Info';
        case 'Subscription':
          return 'Subscription';
        case 'TOS':
          return 'TOS';
        case 'Password':
          return 'Password';
        case 'Privacy':
          return 'Privacy';
        default:
          return '';
      }
    },
  },
  methods: {
    ...orgMethods,
    linkClass(icon) {
      if (this.$route.name === icon) {
        if (icon === 'chat') {
          return ['chat-selected', 'text-selected'];
        }
        return ['icon-selected', 'text-selected'];
      } else {
        if (icon === 'chat') {
          return ['chat', 'text'];
        }
        return ['icon', 'text'];
      }
    },
  },
};
</script>

<template>
  <footer :style="colors">
    <b-card class="view" no-body>
      <b-tabs class="menu" card end justified>
        <b-tab>
          <template v-slot:title>
            <router-link to="/home">
              <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="linkClass('home')[0]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7 1.793l3.333 3V10H9V6H5v4H3.667V4.793l3.333-3zM7 0L.333 6h2v5.333h4v-4h1.334v4h4V6h2L7 0z" fill="#000"/></svg>
              <br />
              <p :class="linkClass('home')[1]">Home</p>
            </router-link>
          </template>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <router-link to="/chat" class="link">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="linkClass('chat')[0]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14.875 8.146a5.936 5.936 0 01-.637 2.691 6.021 6.021 0 01-5.384 3.33 5.936 5.936 0 01-2.691-.638l-4.038 1.346 1.346-4.037a5.936 5.936 0 01-.638-2.692 6.02 6.02 0 013.33-5.384 5.936 5.936 0 012.691-.637h.354a6.007 6.007 0 015.667 5.667v.354z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8.854" cy="8.146" fill="#000" r="1.063"/><circle cx="11.688" cy="8.146" fill="#000" r="1.063"/><circle cx="6.021" cy="8.146" fill="#000" r="1.063"/></svg>
              <br />
              <p :class="linkClass('chat')[1]">Chat</p>
            </router-link>
          </template>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <router-link to="/profile/info">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="linkClass(profilePage)[0]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 .667A2.667 2.667 0 116 6 2.667 2.667 0 016 .667zM6 2a1.333 1.333 0 100 2.667A1.333 1.333 0 006 2zm0 4.667c1.78 0 5.333.886 5.333 2.666v2H.667v-2C.667 7.553 4.22 6.666 6 6.666zm0 1.266c-1.98 0-4.067.973-4.067 1.4v.733h8.134v-.733c0-.427-2.087-1.4-4.067-1.4z" fill="#000"/></svg>
              <br />
              <p :class="linkClass(profilePage)[1]">Profile</p>
            </router-link>
          </template>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <!-- <b-icon-person small></b-icon-person> -->
            <router-link to="/nutrition">
              <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="linkClass('nutrition')[0]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.333 5.667a3.512 3.512 0 00-4.666-1.334V1H5.333v3.333A3.512 3.512 0 00.667 5.667c-1.334 2 2 8 3.333 8 1.333 0 1.333-.667 2-.667s.667.666 2 .666 4.667-6 3.333-8zM10.167 7.92A10.272 10.272 0 017.8 12.333a.644.644 0 01-.4-.167c-.82-.66-1.98-.66-2.8 0a.644.644 0 01-.4.167 10.178 10.178 0 01-2.367-4.406 2.549 2.549 0 01-.06-1.514 2.246 2.246 0 011.894-1.146c.373.006.74.093 1.073.26l.593.3h1.334l.593-.3a2.48 2.48 0 011.073-.26 2.24 2.24 0 011.894 1.14c.14.5.106 1.026-.06 1.513zM5.333 2.333C1.587 4.38.74 1.52.74 1.52s1.773-2.393 4.593.813z" fill="#000"/></svg>
            </router-link>
            <br />
            <p :class="linkClass('nutrition')[1]">Nutrition</p>
          </template>
        </b-tab>
      </b-tabs>
    </b-card>
  </footer>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .owl-carousel {
  .owl-stage {
    align-items: center;
    display: flex;
    padding: 2rem 0;

    .owl-item:not(.center) {
      .card-goals.mobile {
        height: 23vh;
      }
    }
  }
}

::v-deep {
  .nav-tabs .nav-link.active {
    border: none;
  }
  .nav-link:hover {
    border: none;
  }
  .tab-content {
    display: none;
  }
  .card-footer {
    background-color: white;
    border-top: none;
    padding: 0.75rem 1.25rem;
  }
  a {
    color: grey;
    text-decoration: none !important;
  }
}

footer {
  bottom: 0;
  position: fixed;
  width: 100%;
  z-index: 9999;

  .view {
    border: none;
    height: 100% !important;

    .menu {
      background-color: none;
      border: none;
      height: 100%;
      width: 100%;

      .text {
        color: $color-medium-gray-alt;
      }
      .text-selected {
        color: $color-black-alt;
      }
      .icon {
        height: 2rem;
        width: 2rem;
        path {
          fill: #6c757d;
        }
      }
      .icon-selected {
        height: 2rem;
        width: 2rem;
        path {
          fill: var(--color);
        }
      }
      .chat {
        height: 2rem;
        width: 2rem;
        path {
          stroke: #6c757d;
        }
        circle {
          fill: #6c757d;
        }
      }
      .chat-selected {
        height: 2rem;
        width: 2rem;
        path {
          stroke: var(--color);
        }
        circle {
          fill: var(--color);
        }
      }
    }
  }
}
</style>
